import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FileNotifStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M16 18C16.4142 18 16.75 18.3358 16.75 18.75C16.75 19.1642 16.4142 19.5 16 19.5H8C7.58579 19.5 7.25 19.1642 7.25 18.75C7.25 18.3358 7.58579 18 8 18H16Z"
				fill="currentColor"
			/>
			<path
				d="M12 14C12.4142 14 12.75 14.3358 12.75 14.75C12.75 15.1642 12.4142 15.5 12 15.5H8C7.58579 15.5 7.25 15.1642 7.25 14.75C7.25 14.3358 7.58579 14 8 14H12Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.25 5.75V21.75C3.25 23.2688 4.48122 24.5 6 24.5H18C19.5188 24.5 20.75 23.2688 20.75 21.75V11.5V10.75C20.75 10.5511 20.6709 10.3604 20.5303 10.2197L20.3105 10H18.1895L19.25 11.0605V21.75C19.25 22.4404 18.6904 23 18 23H6C5.30964 23 4.75 22.4404 4.75 21.75V5.75C4.75 5.05964 5.30964 4.5 6 4.5H12.6895L13.75 5.56055V3.43945L13.5303 3.21973C13.3896 3.07907 13.1989 3 13 3H12.25H6C4.48122 3 3.25 4.23122 3.25 5.75Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.25 8.75V3H13C13.1989 3 13.3896 3.07907 13.5303 3.21973L13.75 3.43945V5.56055V8.75C13.75 9.44036 14.3096 10 15 10H18.1895H20.3105L20.5303 10.2197C20.6709 10.3604 20.75 10.5511 20.75 10.75V11.5H15C13.4812 11.5 12.25 10.2688 12.25 8.75Z"
				fill="currentColor"
			/>
			<circle cx="18.75" cy="5" r="4" fill="#1E72BD" stroke="white" strokeWidth="2" />
		</svg>
	);
}

FileNotifStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FileNotifStrokeIcon;
